var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingPresetList",
      "extra-items": _vm.isEditing ? [{
        text: _vm.bookingPreset.name,
        to: 'BookingCenterBookingList',
        params: _vm.$route.params.id
      }, '編輯預約設定檔'] : ['新增預約設定檔']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('StepNavigation', {
    ref: "stepNavigation",
    attrs: {
      "steps": _vm.navigationSteps
    },
    on: {
      "changed": function changed(newStep) {
        return _vm.step = newStep.hash;
      }
    }
  })], 1), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? "編輯預約設定檔" : "新增預約設定檔") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*名稱"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.bookingPreset.name.$error ? false : null
    },
    model: {
      value: _vm.bookingPreset.name,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "name", $$v);
      },
      expression: "bookingPreset.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*預約類型"
    }
  }, [_vm.hasBookingPresetTypePermission ? _c('b-form-radio-group', {
    attrs: {
      "options": _vm.bookingPresetTypes
    },
    model: {
      value: _vm.bookingPreset.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "type", $$v);
      },
      expression: "bookingPreset.type"
    }
  }) : _c('p', {
    staticClass: "mt-1"
  }, [_vm._v(" 無權限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約說明"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.bookingPreset.config.description,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "description", $$v);
      },
      expression: "bookingPreset.config.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約狀態"
    }
  }, [_c('OptionsEditor', {
    attrs: {
      "default-value": _vm.bookingPreset.config.booking_mapping.default_status_value,
      "header-is-visible": true,
      "default-option-is-visible": true
    },
    on: {
      "update:defaultValue": function updateDefaultValue($event) {
        return _vm.$set(_vm.bookingPreset.config.booking_mapping, "default_status_value", $event);
      },
      "update:default-value": function updateDefaultValue($event) {
        return _vm.$set(_vm.bookingPreset.config.booking_mapping, "default_status_value", $event);
      }
    },
    model: {
      value: _vm.statusConfigField.options,
      callback: function callback($$v) {
        _vm.$set(_vm.statusConfigField, "options", $$v);
      },
      expression: "statusConfigField.options"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "disabled": !_vm.hasBookingPresetTypePermission,
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#time-setting' ? _c('section', [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "格式 *"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "input-group",
    attrs: {
      "options": [{
        text: '日期 + 時間',
        value: 'datetime'
      }, {
        text: '日期',
        value: 'date'
      }, {
        text: '時間',
        value: 'time'
      }]
    },
    model: {
      value: _vm.timeConfigField.format,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "format", $$v);
      },
      expression: "timeConfigField.format"
    }
  })], 1), (_vm.timeConfigField.format || '').includes('date') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期格式 *"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '自行選擇日期',
        value: 'unlimited'
      }, {
        text: '限定日期選項',
        value: 'limited'
      }, {
        text: '週期日期',
        value: 'periodic',
        disabled: true
      }]
    },
    model: {
      value: _vm.timeConfigField.date_condition,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "date_condition", $$v);
      },
      expression: "timeConfigField.date_condition"
    }
  })], 1) : _vm._e(), (_vm.timeConfigField.format || '').includes('date') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期呈現樣式"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '日曆',
        value: 'calendar_style'
      }, {
        text: '下拉選項',
        value: 'select_style'
      }]
    },
    model: {
      value: _vm.timeConfigField.date_style,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "date_style", $$v);
      },
      expression: "timeConfigField.date_style"
    }
  })], 1) : _vm._e(), (_vm.timeConfigField.format || '').includes('date') && _vm.timeConfigField.date_condition == 'limited' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "選項 *"
    }
  }, [_c('OptionsEditor', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.timeConfigField.options,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "options", $$v);
      },
      expression: "timeConfigField.options"
    }
  })], 1) : _vm._e(), (_vm.timeConfigField.format || '').includes('time') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間格式 *"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "input-group",
    attrs: {
      "options": [{
        text: '自行選擇時間',
        value: 'unlimited'
      }, {
        text: '限定時間選項',
        value: 'limited'
      }]
    },
    on: {
      "change": function change($event) {
        _vm.timeConfigField.time_condition === 'unlimited' ? _vm.timeConfigField.time_style = 'time_select_style' : _vm.timeConfigField.time_style = 'select_style';
      }
    },
    model: {
      value: _vm.timeConfigField.time_condition,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "time_condition", $$v);
      },
      expression: "timeConfigField.time_condition"
    }
  })], 1) : _vm._e(), (_vm.timeConfigField.format || '').includes('time') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "時間呈現樣式"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '時間下拉',
        value: 'time_select_style',
        disabled: true
      }, {
        text: '自訂下拉',
        value: 'select_style',
        disabled: _vm.timeConfigField.time_condition === 'unlimited'
      }, {
        text: '按鈕選項',
        value: 'button_style',
        disabled: _vm.timeConfigField.time_condition === 'unlimited'
      }]
    },
    model: {
      value: _vm.timeConfigField.time_style,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "time_style", $$v);
      },
      expression: "timeConfigField.time_style"
    }
  })], 1) : _vm._e(), (_vm.timeConfigField.format || '').includes('time') && _vm.timeConfigField.time_condition == 'limited' ? [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間 *"
    }
  }, [_c('AppTimePicker', {
    model: {
      value: _vm.timeConfigField.start_time,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "start_time", $$v);
      },
      expression: "timeConfigField.start_time"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間 *"
    }
  }, [_c('AppTimePicker', {
    model: {
      value: _vm.timeConfigField.end_time,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "end_time", $$v);
      },
      expression: "timeConfigField.end_time"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每個時間區段單位 *"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.timeConfigField.slot_minutes,
      callback: function callback($$v) {
        _vm.$set(_vm.timeConfigField, "slot_minutes", $$v);
      },
      expression: "timeConfigField.slot_minutes"
    }
  })], 1)] : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預約時長"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.bookingPreset.config.basic.duration_minutes,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic, "duration_minutes", $$v);
      },
      expression: "bookingPreset.config.basic.duration_minutes"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "提前預約設定"
    }
  }, [_c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "lead-time-options",
      "value": "none"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "type", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.type"
    }
  }), _vm._v(" 無需提前預約 ")], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "lead-time-options",
      "value": "day"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "type", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.type"
    }
  }), _vm._v(" 需提前 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.lead_time.type !== 'day',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.amount_day,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "amount_day", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.amount_day"
    }
  }), _vm._v(" 天預約 ")], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "lead-time-options",
      "value": "minute"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "type", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.type"
    }
  }), _vm._v(" 需提前 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.lead_time.type !== 'minute',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.lead_time.amount_minute,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.lead_time, "amount_minute", $$v);
      },
      expression: "bookingPreset.config.basic.lead_time.amount_minute"
    }
  }), _vm._v(" 分鐘預約 ")], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*預約時間限制"
    }
  }, [_c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "booking-window-options",
      "value": "none"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "type", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.type"
    }
  }), _vm._v(" 不限制 ")], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "booking-window-options",
      "value": "day"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "type", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.type"
    }
  }), _vm._v(" 只能預約 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.booking_window.type !== 'day',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.amount_day,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "amount_day", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.amount_day"
    }
  }), _vm._v(" 天內的預約 "), _c('span', {
    staticClass: "ml-2",
    attrs: {
      "id": "booking-window-tooltip-trigger"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-help-circle-outline"
  })]), _c('b-tooltip', {
    attrs: {
      "target": "booking-window-tooltip-trigger",
      "placement": "top"
    }
  }, [_vm._v(" 1 天代表當日；2 代表當日與隔日 ")])], 1), _c('br'), _c('label', {
    staticClass: "py-2 d-inline-flex align-items-center"
  }, [_c('b-form-radio', {
    attrs: {
      "name": "booking-window-options",
      "value": "minute"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "type", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.type"
    }
  }), _vm._v(" 只能預約未來 "), _c('b-form-input', {
    staticClass: "d-inline-block mx-1",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.bookingPreset.config.basic.booking_window.type !== 'minute',
      "type": "number",
      "min": "0",
      "size": "sm"
    },
    model: {
      value: _vm.bookingPreset.config.basic.booking_window.amount_minute,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.basic.booking_window, "amount_minute", $$v);
      },
      expression: "bookingPreset.config.basic.booking_window.amount_minute"
    }
  }), _vm._v(" 分鐘內的預約 ")], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 2) : _vm._e(), _vm.step == '#business-hours' ? _c('section', [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "reservation-periods-container"
  }, [_c('div', {
    staticClass: "row reservation-periods-header"
  }, [_c('div', {
    staticClass: "col-2"
  }), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("例行公休日")]), _c('div', {
    staticClass: "col-3 text-center"
  }, [_vm._v("預約開始時間")]), _c('div', {
    staticClass: "col-3 text-center"
  }, [_vm._v("最後預約時間")]), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("當日休店時間")])]), _vm._l(_vm.reservationPeriods, function (period, dayIndex) {
    return _c('div', {
      key: dayIndex,
      staticClass: "row reservation-period-row align-items-center mb-2"
    }, [_c('div', {
      staticClass: "col-2"
    }, [_c('span', [_vm._v(_vm._s(period.display_text))])]), _c('div', {
      staticClass: "col-2 text-center"
    }, [_c('b-form-checkbox', {
      on: {
        "change": function change($event) {
          return _vm.updateReservationPeriod(dayIndex, 'is_official_holiday', $event);
        }
      },
      model: {
        value: period.is_official_holiday,
        callback: function callback($$v) {
          _vm.$set(period, "is_official_holiday", $$v);
        },
        expression: "period.is_official_holiday"
      }
    })], 1), _c('div', {
      staticClass: "col-3"
    }, [_c('AppTimePicker', {
      attrs: {
        "styleType": "unlimited",
        "disabled": period.is_official_holiday
      },
      on: {
        "input": function input($event) {
          return _vm.updateReservationPeriod(dayIndex, 'start_time', $event);
        }
      },
      model: {
        value: period.business_hours[0].start_time,
        callback: function callback($$v) {
          _vm.$set(period.business_hours[0], "start_time", $$v);
        },
        expression: "period.business_hours[0].start_time"
      }
    })], 1), _c('div', {
      staticClass: "col-3"
    }, [_c('AppTimePicker', {
      attrs: {
        "styleType": "unlimited",
        "disabled": period.is_official_holiday
      },
      on: {
        "input": function input($event) {
          return _vm.updateReservationPeriod(dayIndex, 'end_time', $event);
        }
      },
      model: {
        value: period.business_hours[0].end_time,
        callback: function callback($$v) {
          _vm.$set(period.business_hours[0], "end_time", $$v);
        },
        expression: "period.business_hours[0].end_time"
      }
    })], 1), _c('div', {
      staticClass: "col-2"
    }, [_c('AppTimePicker', {
      attrs: {
        "styleType": "unlimited",
        "disabled": period.is_official_holiday
      },
      on: {
        "input": function input($event) {
          return _vm.updateReservationPeriod(dayIndex, 'closing_time', $event);
        }
      },
      model: {
        value: period.closing_time,
        callback: function callback($$v) {
          _vm.$set(period, "closing_time", $$v);
        },
        expression: "period.closing_time"
      }
    })], 1)]);
  })], 2), _c('div', {
    staticClass: "d-flex justify-content-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#limit-setting' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約設定檔名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('b-form-radio-group', {
    staticClass: "pt-3",
    on: {
      "input": _vm.handleOccupanceLimitTypeChange
    },
    model: {
      value: _vm.bookingPreset.config.occupy_config.limit_type,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config.occupy_config, "limit_type", $$v);
      },
      expression: "bookingPreset.config.occupy_config.limit_type"
    }
  }, [_c('b-form-radio', {
    staticClass: "form-inline w-100 mb-2",
    attrs: {
      "value": "unlimited"
    }
  }, [_vm._v(" 不限定 ")]), _c('div', {
    staticClass: "d-flex align-items-center w-100 mb-2"
  }, [_c('b-form-radio', {
    staticClass: "mr-0",
    attrs: {
      "value": "time"
    }
  }), _vm._v(" 每時段固定 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.bookingPreset.config.occupy_config.slot_people,
      expression: "bookingPreset.config.occupy_config.slot_people"
    }],
    staticClass: "form-control mx-2",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.bookingPreset.config.occupy_config.slot_people
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookingPreset.config.occupy_config, "slot_people", $event.target.value);
      }
    }
  }), _vm._v(" 人 ")], 1), _c('b-form-radio', {
    staticClass: "form-inline w-100 mb-2",
    attrs: {
      "value": "collection",
      "disabled": ""
    }
  }, [_vm._v(" C 商品[規格]：分店 ")])], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _vm.step == '#fields' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '預約名稱',
      "name": _vm.bookingPreset.name
    }
  }), _c('div', [_c('DynamicFormEditor', {
    attrs: {
      "editor-title": "欄位設定",
      "form-type": 'booking',
      "input-subjects": _vm.sortableFields,
      "subject-is-fixed": _vm.subjectIsFixed,
      "pages": _vm.bookingPreset.config.pages,
      "sections": _vm.bookingPreset.config.sections,
      "validate-subject": _vm.validSubject,
      "validation-message": "標題不得為空",
      "enable-visible-condition": ""
    },
    on: {
      "output": _vm.saveFields,
      "cancel": function cancel($event) {
        return _vm.$router.push({
          name: 'BookingPresetList'
        });
      }
    }
  })], 1)], 1) : _vm._e(), _vm.step == '#publish' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "填寫權限"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.permissionOptions
    },
    model: {
      value: _vm.bookingPreset.config.permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset.config, "permissions", $$v);
      },
      expression: "bookingPreset.config.permissions"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發布狀態"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.bookingPreset.status,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "status", $$v);
      },
      expression: "bookingPreset.status"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "published"
    }
  }, [_vm._v("發布")]), _c('b-form-select-option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("草稿")]), _c('b-form-select-option', {
    attrs: {
      "value": "closed"
    }
  }, [_vm._v("關閉")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 開始時間"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "placeholderForDate": "選擇日期",
      "placeholderForTime": "選擇時間",
      "has-error": _vm.v$.bookingPreset.start_at.$error
    },
    model: {
      value: _vm.bookingPreset.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "start_at", $$v);
      },
      expression: "bookingPreset.start_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.start_at.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 結束時間"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "placeholderForDate": "選擇日期",
      "placeholderForTime": "選擇時間",
      "has-error": _vm.v$.bookingPreset.end_at.$error || _vm.v$.bookingPreset.start_at.beforeEndAt.$invalid
    },
    model: {
      value: _vm.bookingPreset.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.bookingPreset, "end_at", $$v);
      },
      expression: "bookingPreset.end_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.end_at.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.bookingPreset.start_at.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "disabled": !_vm.hasBookingPresetTypePermission,
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }